import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    goBack(event) {
        event.preventDefault();

        // Simply go back in history
        // The calendar-events-controller on the homepage will handle the scroll
        if (window.history.length > 1 && document.referrer) {
            window.history.back();
        } else {
            // Fallback to homepage
            window.location.href = this.element.getAttribute('href') || '/';
        }
    }
}
